__webpack_require__.p = "/snake_game/";